/* eslint-disable max-lines-per-function */
/* eslint-disable no-loop-func */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable max-lines */
import {
    rpcStatisticStudent,
    submitAnswer,
    closeWindow,
    startHeartbeat,
} from '@/utils/courseware-sdk';
import {getQuestionDetail} from '@/api/api';
import {handleSendMessageApp, questionErrorReport, sendMessageAppInOnlineWithoutFetch} from './questionUtils';
// 心跳端能力定时器
let heartbeatTimer: any = null;

declare global {
    interface Window {
        maodou: any;
        webkit: any;
        WeixinJSBridge: any;
        collectEvent: any;
        callbackMap: any;
        attendanceMap: any;
        PIXI: any;
        __ORIGINAL_PIXI__?: any;
    }
    interface Document {
        attachEvent: any;
    }
    interface objMap {
        [key: number]: any;
        [key: string]: any;
    }
}

/**
 * 检测是否web端调试环境
 * @returns 是否web端调试环境
 */
export const isWebEnv = () => {
    try {
        // 识别是否为开发环境
        return process.env.NODE_ENV === 'development';
    }
    catch (error) {
        return false;
    }
};

export const INTELLIGENT_DEVICES = ['xiaoai', 'xiaodu', 'tmall'];

export const isWXBrower = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    return (/MicroMessenger/i).test(ua);
};

export const isAndroid = () => {
    const u = navigator.userAgent;
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
};

export const isIOS = () => {
    const u = navigator.userAgent;
    // return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    return !!u.match(/\((i|M)[^;]+;( U;)? (CPU|Intel).+Mac OS X/);
};

export const isPC = () => !(isAndroid() || isIOS());

export const isIPAD = () => {
    const re = /ipad/i;
    const u = navigator.userAgent;
    return re.test(u);
};

// 获取微信appid
export const getAppId = () => (window.location.origin.includes('test-') ? 'wx874724d8acf3dc9d' : 'wxe02cd0bed85c4388');

// 微信支付api
export const applyWxPay = (item:any, callback:any) => {
    console.log(item);
    // 支付流程：https://pay.weixin.qq.com/wiki/doc/api/index.html
    //         https://pay.weixin.qq.com/wiki/doc/api/jsapi.php?chapter=7_3
    //     公众号/小程序：wxe02cd0bed85c4388
    // APP：wx903594676f4f48d9
    // 新app微信的key得换成这个
    // appsecretkey 019743d71dd8c769079cd6247d9cff9d
    function onBridgeReady() {
        console.log('进入调起支付');
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
                // 公众号名称，由商户传入
                appId: item ? item.appId : 'wxe02cd0bed85c4388',
                // wxe02cd0bed85c4388    process.env.payConfig.appId
                // 时间戳，自1970年以来的秒数
                timeStamp: item ? item.timeStamp : '1395712654',
                // 随机串
                nonceStr: item ? item.nonceStr : 'e61463f8efa94090b1f366cccfbbb444',
                package: item ? item.package : 'prepay_id=u802345jgfjsdfgsdg888',
                // 微信签名方式
                signType: item ? item.signType : 'MD5',
                // 微信签名
                paySign: item ? item.paySign : '70EA570631E4BB79628FBCA90534C63FF7FADD89'
            },
            (res:any) => {
                if (res.err_msg === 'get_brand_wcpay_request:ok') {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠.
                    callback && callback();
                    // 向后端轮询支付结果
                    console.log('微信返回支付成功');
                }
                else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                    // 用户取消支付
                    console.log('用户取消支付');
                }
                else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                    // 支付失败
                    console.log('微信返回支付失败');
                }
            }
        );
    }

    if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        }
        else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    }
    else {
        onBridgeReady();
    }
};

export const delWXparams = (url:string) => {
    let newUrl = url || location.href;
    if (/from=[^&$?]{1,}(&|$)/.test(location.search) || /isappinstalled=[^&$?]{1,}(&|$)/.test(location.search)) {
        const newSearch = location.search.replace(/from=[^&$?]{1,}(&|$)/, '').replace(/isappinstalled=[^&$?]{1,}(&|$)/, '')
            .replace(/&$|\?$/, '');
        newUrl = location.origin + location.pathname + newSearch + location.hash;
    }
    return newUrl;
};

// 初始化微信分享
export const initWXShare = (obj:any, wxShare:Function) => {
    const newUrl:string = delWXparams(location.origin + obj.fullPath);
    const link:string = encodeURIComponent(newUrl);
    console.log('url=', link);

    const parms = {
        title: obj.title || '欢迎使用毛豆爱学',
        desc: obj.desc || '孩子学了都喜欢~',
        link,
        imgUrl: obj.imgUrl || 'https://i.gsxcdn.com/feihua/20201215/ptQq_1608039151.png',
    };
    wxShare(parms, () => {
        console.log('微信分享调用成功……');
    });
};

// 获取随机数
export const getRandom = (minNum:any, maxNum:any) => parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);

/**
 * 更新缓存中的用户信息的属性值
 */
export const updateUserInfo = (key:string, val:any) => {
    console.log('进入更新缓存');
    const str:any = window.localStorage.getItem(`${window.location.host}userInfo`);
    const userInfo = JSON.parse(str);
    userInfo[key] = val;
    window.localStorage.setItem(`${window.location.host}userInfo`, JSON.stringify(userInfo));
};

/**
 * 获取缓存中的对象值
 * @param {*} item 缓存的对象
 * @returns
 */
export const getLocalStorageItem = (item:string) => {
    const infoStr = window.localStorage.getItem(item);
    return infoStr ? JSON.parse(infoStr) : null;
};

/**
 * 设置缓存中的对象值
 * @param {*} item 缓存的对象名称
 * @param {*} value 缓存的对象值
 * @returns
 */
export const setLocalStorageItem = (item:string, value:any) => {
    value && window.localStorage.setItem(item, JSON.stringify(value));
};

/**
 * 删除缓存中的对象值
 * @param {*} item 缓存的对象名称
 * @returns
 */
export const removeLocalStorageItem = (item:string) => {
    window.localStorage.removeItem(item);
};

/**
     * 节流函数
     * @param {*}
     * @returns
     */
export const throttle = (fn:any, delay:number) => {
    let last = new Date().getTime();
    let deferTimer:any = null;
    return function (...args:any) {
        const now = new Date().getTime();
        if (now < last + delay) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(() => {
                last = now;
                fn.apply(this, args);
            }, delay);
        }
        else {
            last = now;
            fn.apply(this, args);
        }
    };
};

/**
 * 版本比较
 */
export const compareVersion = (v1:string, v2:string) => {
    if (!v1 || !v2) {
        console.error('版本号值为空');
        return;
    }
    const a1:any = v1.split('.');
    const a2:any = v2.split('.');
    if (a1.length < 3 || a2.length < 3) {
        console.error('版本号应为三位');
        return;
    }
    return (a1[0] - a2[0] as any) || (a1[1] - a2[1] as any) || (a1[2] - a2[2] as any);
};

/**
 * 将日期改为 2021-07-02 的格式
 * @param str
 */
export const formatDate = (str:string) => {
    let [year, month, day] = str.split('-');

    month = Number(month) < 10 ? `0${month}` : month;
    day = Number(day) < 10 ? `0${day}` : day;

    return `${year}-${month}-${day}`;
};

/**
 * 补0逻辑
 * @param str
 */
export const addZero = (num:any) => (num < 10 ? `0${num}` : num.toString());

// 按照竖屏计算html的font-size
export const resetFontSize = () => {
    // html根元素
    const HTML_ELEMENT = document.documentElement;
    // 屏幕宽度
    let SCREEN_WIDTH = 0;
    // 标准fontSize计算值
    let BASE_FONT_SIZE = 0;
    // 处理后的fontSize计算值
    const REAL_BASE_FONT_SIZE = 0;
    console.log('竖屏状态！');
    SCREEN_WIDTH = HTML_ELEMENT.clientWidth;
    // 将屏幕分成10份，获取每一份宽度
    BASE_FONT_SIZE = SCREEN_WIDTH / 10;
    // 写入html元素fontSize
    // HTML_ELEMENT.style.fontSize = `${BASE_FONT_SIZE}px`;
    console.log(`打印根元素fontSize=${HTML_ELEMENT.style.fontSize}`);
};

export const setUrlQuery = (options: {url: string; query: any}) => {
    let {url, query} = options;
    if (!url) {
        return '';
    }
    if (query) {
        console.log('query', query);

        const queryArr = [];
        for (const key in query) {
            if (query.hasOwnProperty(key)) {
                queryArr.push(`${key}=${query[key]}`);
            }
        }
        if (url.indexOf('?') !== -1) {
            url = `${url}&${queryArr.join('&')}`;
        }
        else {
            url = `${url}?${queryArr.join('&')}`;
        }
    }
    return url;
};


/**
 * @description 判断当前浏览器环境是否支持 WebP 格式
 * @param {string} [feature='lossless'] WebP 功能
 * @return {Promise<boolean>} 描述是否支持 WebP 格式的 Promise 对象
 */

export const isSupportWebP = (feature = 'lossless') => {
    const testImages = {
        lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
        lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
        alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
        animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
    };

    return new Promise(resolve => {
        const _image = new Image();
        _image.onload = () => {
            const result = _image.width > 0 && _image.height > 0;
            resolve(result);
        };
        _image.onerror = () => {
            resolve(false);
        };
        // @ts-ignore
        _image.src = `data:image/webp;base64,${testImages[feature]}`;
    });
};

/**
 * @description 打乱数组
 * @param {Array<unknown>} list 需要打乱的数组
 * @return {Array<unknown>} 打乱后的数组
 */
export const shuffleArray = (list: unknown[]) => {
    for (let i = list.length - 1; i > 0; i--) {
        // 生成随机索引
        const j = Math.floor(Math.random() * (i + 1));
        // 交换元素位置
        [list[i], list[j]] = [list[j], list[i]];
    }
    return list;
};

type ImgPosition =
    | 'center'
    | 'leftCenter'
    | 'rightCenter'
    | 'topCenter'
    | 'bottomCenter'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom';
interface ImgCoverSize {
    coverLeft: number;
    coverRight: number;
    coverTop: number;
    coverBottom: number;
    ratio: number;
}

/**
 * @description 特定大小的图片全屏cover模式展示后，被裁减了多少，以及缩放比例
 * @param {number} coverWidth 图片宽度
 * @param {number} coverHeight 图片高度
 * @param {ImgPosition} coverHeight 图片排列方式
 * @return {ImgCoverSize} 图片裁减尺寸(原始尺寸)
 */
export const getCoverSize = (coverWidth: number, coverHeight: number, type:ImgPosition = 'center'): ImgCoverSize => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const res = {
        coverLeft: 0,
        coverRight: 0,
        coverTop: 0,
        coverBottom: 0,
        ratio: 1,
    };

    if (coverWidth / width > coverHeight / height) {
        // 高度撑满，左右裁剪
        res.ratio = height / coverHeight;
        res.coverLeft = coverWidth - width / res.ratio;
    }
    else {
        // 宽度撑满，上下裁剪
        res.ratio = width / coverWidth;
        res.coverTop = coverHeight -  height / res.ratio;
    }

    switch (type) {
        case 'center':
            res.coverRight = res.coverLeft / 2;
            res.coverLeft /= 2;
            res.coverBottom = res.coverTop / 2;
            res.coverTop /= 2;
            break;
        case 'leftCenter':
            res.coverBottom = res.coverTop / 2;
            res.coverTop /= 2;
            break;
        case 'rightCenter':
            res.coverRight = res.coverLeft;
            res.coverBottom = res.coverTop / 2;
            res.coverTop /= 2;
            break;
        case 'topCenter':
            res.coverRight = res.coverLeft / 2;
            res.coverLeft /= 2;
            break;
        case 'bottomCenter':
            res.coverRight = res.coverLeft / 2;
            res.coverLeft /= 2;
            res.coverBottom = res.coverTop;
            break;
        case 'leftTop':
            break;
        case 'leftBottom':
            res.coverBottom = res.coverTop;
            break;
        case 'rightTop':
            res.coverRight = res.coverLeft;
            break;
        case 'rightBottom':
            res.coverRight = res.coverLeft;
            res.coverBottom = res.coverTop;
            break;
    }

    return res;
};

/**
 * 解析url参数
 */
export const parseUrl = () => {
    if (typeof window !== 'object' || !window.document) {
        return {};
    }

    const url = window.document.location.href.toString();
    const urlArray = url.split('#');
    const get:any = {};
    for (const url of urlArray) {
        const list = url.split('?');
        for (let i = 1; i < list.length; i++) {
            const u = list[i].split('&');
            for (let i = 0, l = u.length; i < l; ++i) {
                const j = u[i];
                const x = j.indexOf('=');
                if (x < 0) {
                    continue;
                }
                const key = j.substring(0, x);
                const value = j.substring(x + 1);
                get[decodeURIComponent(key)] = value && decodeURIComponent(value);
            }
        }
    }

    return get;
};

/**
 * 检测是否教师模式
 * @returns 是否教师模式
 */
export const isTeacherMode = () => parseUrl().maodouQuestionRunTime === 'teacher';

/**
 * 检测是否gaotu端环境
 * @returns 是否gaotu端环境
 */
export const isGaotuEnv = () => parseUrl().source === 'gaotu';


export const sendMessageAppInGaotu = (fnName:any, param?:any) => {
    const loadFinish = async () => {
        !isWebEnv() && (heartbeatTimer = setInterval(() => {
            // 调用高途互动题答题SDK - 每隔2s向端上发送一次心跳
            console.log('！！！调用高途互动题答题SDK：startHeartbeat();心跳端能力每两秒调用一次');
            startHeartbeat();
        }, 2000));
        console.log('！！！调用高途互动题答题SDK：rpcStatisticStudent({status: 0});');
        rpcStatisticStudent({status: 0});
        console.log('在高途APP中');
        const {questionId} = parseUrl();
        console.log('即将调用接口的 questionId', questionId);
        // 调用获取题目数据接口
        const res: any = await getQuestionDetail({
            questionId,
            sign: '6f7ab01a51d64d7b82479ac7a3279a72',
        });
        if (res.code === '0') {
            console.log('看看res.data', res.data);
            const questionStr = JSON.stringify({
                params: res.data,
            });
            // 将题目数据传给题目
            window.callbackMap.setQuestionParams && window.callbackMap.setQuestionParams(questionStr);
            window.callbackMap.setNewQuestionParams && window.callbackMap.setNewQuestionParams(questionStr);
        }
    };
    const startQuestion = () => {
        // 调用高途互动题答题SDK - 向后端发送信息，统计学生状态，status=1为初始化
        console.log('！！！调用高途互动题答题SDK：rpcStatisticStudent({status: 1});');
        rpcStatisticStudent({status: 1});
    };
    const finishedQuestion = async () => {
        // 调用高途互动题答题SDK - 提交答案
        console.log('！！！调用高途互动题答题SDK：submitAnswer();');
        await submitAnswer();
        // 调用高途互动题答题SDK - 关闭弹窗
        console.log('！！！调用高途互动题答题SDK：closeWindow();');
        closeWindow();
        // 清除心跳端能力定时器
        heartbeatTimer && clearInterval(heartbeatTimer);
        heartbeatTimer = null;
    };
    const obj:any = {
        loadFinish,
        startQuestion,
        finishedQuestion,
    };
    if (obj[fnName]) {
        obj[fnName](typeof param === 'object' ? JSON.stringify(param) : param);
    }
};

/**
 * 检测是否通过在线加载题目数据
 * @returns 加载题目是否通过在线接口
 */
export const isOnlineParamsEnv = () => Number(parseUrl().isOnlineParams) === 1;

// 标记版本，从此版本，哪些由在线接口获取数据的题目，回归到客户端传递数据
export const isOnlineParamsEnvNext = () => Number(parseUrl().isOnlineParams) === 2;


const handleQuestionItem = (item: any, fileMap: Map<string, string>) => {
    // 获取item的type，只处理对象和数组
    const itemType = Object.prototype.toString.call(item);
    consoleLog('handleQuestionItem', itemType, item);
    if (itemType === '[object Object]') {
        // 处理对象
        for (const key of Object.keys(item)) {
            const value = item[key];
            const innerType = Object.prototype.toString.call(value);
            if (innerType === '[object Object]') {
                handleQuestionItem(value, fileMap);
            }
            else if (innerType === '[object Array]') {
                value.forEach((value: any) => handleQuestionItem(value, fileMap));
            }
            else if (innerType === '[object String]' && fileMap.has(value) && !value.includes('|')) {
                const localPath = fileMap.get(value);
                consoleLog('命中本地资源', value, localPath);
                localPath && (item[key] = localPath);
                consoleLog('item', item);
                consoleLog('key', item[key]);
            }
        }
    }
    else if (itemType === '[object Array]') {
        // 处理数组
        item.forEach((value: any) => handleQuestionItem(value, fileMap));
    }
};

const checkCanHandleQuestionData = (newParams: any) => {
    const {params, fileList} = newParams;
    consoleLog('checkCanHandleQuestionData params', params);
    consoleLog('checkCanHandleQuestionData fileList', fileList);
    const qTypeId = params.typeId || params.qTypeId;
    consoleLog('checkCanHandleQuestionData qTypeId', qTypeId);
    if (!fileList?.length) {
        return false;
    }
    // 针对用户机型单独处理
    if (qTypeId === 10009 && navigator.userAgent.includes('Android 15; PJH110')) {
        consoleLog('checkCanHandleQuestionData 针对用户机型单独处理，不使用本地资源');
        return false;
    }
    // 因这些题的图片资源为拼接在一起的，故不使用本地资源映射
    // const notUseLocalResourceQTypes = [30001, 30002, 30006, 30007, 30008, 30009, 30010, 30011];
    // if (notUseLocalResourceQTypes.includes(qTypeId)) {
    //     consoleLog('checkCanHandleQuestionData 采用下发资源，不使用本地资源');
    //     return false;
    // }

    return true;
};

const handleQuestionData = (newParams: any) => {
    const canHandle = checkCanHandleQuestionData(newParams);
    consoleLog('handleQuestionData canHandle', canHandle);
    if (!canHandle) {
        return;
    }
    const {params, fileList} = newParams;
    const fileMap: Map<string, string> = new Map(fileList.map((item: {original: string; local: string}) => [item.original, item.local]));
    // console.dir(fileMap);
    consoleLog('fileMapSize', fileMap.size);
    handleQuestionItem(params.qBody, fileMap);
    handleQuestionItem(params.qSelection, fileMap);
};

// 跳题处理函数
const skipQuestion = () => {
    sendMessageApp('finishedQuestion', JSON.stringify({score: '1'}));
};

// 带超时的单次请求
const fetchQuestionWithTimeout = (questionId: string, randomSign: string, retryCount: number): Promise<any> => new Promise((resolve, reject) => {
    // 请求超时时间
    const REQUEST_TIMEOUT = 2000;

    let settled = false;
    const timeoutId = setTimeout(() => {
        if (!settled) {
            consoleLog('题目数据接口超市');
            settled = true;
            reject(new Error(`REQUEST_TIMEOUT_${retryCount}`));
        }
    }, REQUEST_TIMEOUT);

    getQuestionDetail({questionId, randomSign, sign: '6f7ab01a51d64d7b82479ac7a3279a72'})
        .then((res: any) => {
            if (!settled) {
                settled = true;
                clearTimeout(timeoutId);
                resolve(res);
            }
        })
        .catch((error: any) => {
            consoleLog('题目数据接口失败', error.message);
            if (!settled) {
                settled = true;
                clearTimeout(timeoutId);
                reject(error);
            }
        });
});

// 获取题目数据（带重试逻辑）
const fetchQuestionDataWithRetry = async (
    questionId: string,
    randomSign: string,
    startTime: number,
    onTimeout: () => void
) => {
    try {
        // 首次请求，2秒超时
        const res = await fetchQuestionWithTimeout(questionId, randomSign, 1);
        consoleLog('题目数据加载成功', questionId, randomSign);
        // window.collectEvent('yd_question_data_load_success', {
        //     code: '0',
        //     msg: '题目数据加载成功',
        //     questionId,
        //     loadTime: Math.round((Date.now() - startTime) / 1000),
        //     callbackId: res.data?.id ?? 0,
        //     buildEnv: process.env.VUE_APP_BUILD_ENV
        // });
        return res;
    }
    catch (error: any) {
        // 首次请求超时，进行重试
        if (error?.message === 'REQUEST_TIMEOUT_1') {
            consoleLog('题目数据首次请求超时，正在重试', questionId, randomSign);
            // window.collectEvent('yd_question_data_load_retry', {
            //     code: '1',
            //     msg: '题目数据首次请求2秒超时，重试中',
            //     questionId,
            //     buildEnv: process.env.VUE_APP_BUILD_ENV
            // });
            // 端能力上报题目数据首次请求超时
            questionErrorReport({
                exceptionErrorcode: 100001,
                errorCode: '-1',
                message: '题目数据首次请求超时',
                extra: JSON.stringify({questionId, randomSign}),
            });

            try {
                // 重试请求，再给2秒
                const res = await fetchQuestionWithTimeout(questionId, randomSign, 2);
                consoleLog('题目数据重试加载成功', questionId, randomSign);
                // window.collectEvent('yd_question_data_load_success', {
                //     code: '0',
                //     msg: '题目数据重试加载成功',
                //     questionId,
                //     loadTime: Math.round((Date.now() - startTime) / 1000),
                //     callbackId: res.data?.id ?? 0,
                //     buildEnv: process.env.VUE_APP_BUILD_ENV
                // });
                return res;
            }
            catch (retryError: any) {
                // 重试也超时或失败
                const isRetryTimeout = retryError?.message === 'REQUEST_TIMEOUT_2';
                const msg = isRetryTimeout ? '题目数据重试2秒超时' : '题目数据重试请求失败';
                consoleLog(msg, questionId, randomSign);
                // window.collectEvent('yd_question_data_load_fail', {
                //     code: '1',
                //     msg,
                //     questionId,
                //     callbackId: -1,
                //     buildEnv: process.env.VUE_APP_BUILD_ENV
                // });
                // 端能力上报题目数据加载失败
                // errorCode: -2 重试后超时, -3 重试后失败
                questionErrorReport({
                    exceptionErrorcode: 100001,
                    errorCode: isRetryTimeout ? '-2' : '-3',
                    message: msg,
                    extra: JSON.stringify({questionId, randomSign}),
                });
                onTimeout();
                throw retryError;
            }
        }

        // 非超时错误（请求本身失败），也进行重试
        consoleLog('题目数据首次请求失败，正在重试', questionId, randomSign);
        // window.collectEvent('yd_question_data_load_retry', {
        //     code: '1',
        //     msg: '题目数据首次请求失败，重试中',
        //     questionId,
        //     buildEnv: process.env.VUE_APP_BUILD_ENV
        // });
        questionErrorReport({
            exceptionErrorcode: 100001,
            errorCode: '-4',
            message: '题目数据首次请求失败',
            extra: JSON.stringify({questionId, randomSign}),
        });

        try {
            const res = await fetchQuestionWithTimeout(questionId, randomSign, 2);
            consoleLog('题目数据重试加载成功', questionId, randomSign);
            // window.collectEvent('yd_question_data_load_success', {
            //     code: '0',
            //     msg: '题目数据重试加载成功（首次非超时失败）',
            //     questionId,
            //     loadTime: Math.round((Date.now() - startTime) / 1000),
            //     callbackId: res.data?.id ?? 0,
            //     buildEnv: process.env.VUE_APP_BUILD_ENV
            // });
            return res;
        }
        catch (retryError: any) {
            const isRetryTimeout = retryError?.message === 'REQUEST_TIMEOUT_2';
            const msg = isRetryTimeout ? '题目数据重试超时（首次非超时失败）' : '题目数据重试失败（首次非超时失败）';
            consoleLog(msg, questionId, randomSign);
            // window.collectEvent('yd_question_data_load_fail', {
            //     code: '1',
            //     msg,
            //     questionId,
            //     callbackId: -1,
            //     buildEnv: process.env.VUE_APP_BUILD_ENV
            // });
            questionErrorReport({
                exceptionErrorcode: 100001,
                errorCode: isRetryTimeout ? '-5' : '-6',
                message: msg,
                extra: JSON.stringify({questionId, randomSign}),
            });
            onTimeout();
            throw retryError;
        }
    }
};

// 处理题目数据加载成功
const handleQuestionLoadSuccess = (res: any, newParams: any) => {
    consoleLog('看看res.data', res.data);
    newParams.params = res.data;
    handleQuestionData(newParams);
    window.callbackMap.setNewQuestionParams(JSON.stringify(newParams));

    if (isOnlineParamsEnv() && !isWebEnv()) {
        startCheckForStutter({
            qTypeId: res.data.typeId || -1,
            qName: res.data.name || '',
            questionId: res.data.id || -1,
        });
    }
};

// 处理题目数据加载失败（接口返回错误码）
const handleQuestionLoadFail = (res: any, questionId: string) => {
    consoleLog('调用获取题目数据接口失败', res);
    const callbackId = res.data?.id ?? 0;
    // window.collectEvent('yd_question_data_load_fail', {
    //     code: res.code,
    //     msg: res.msg,
    //     questionId,
    //     callbackId,
    //     buildEnv: process.env.VUE_APP_BUILD_ENV
    // });

    // 请求失败不跳题了，正常走超时逻辑
    // skipQuestion();
};

export const sendMessageAppInOnline = async (fnName: string) => {
    if (fnName !== 'loadFinish') {
        return;
    }

    const {questionId} = parseUrl();
    const randomSign = String(Math.random()).slice(2);
    consoleLog(`即将调用接口的 questionId ${questionId}, ${randomSign}`);

    const newParams = {
        params: '',
        uid: '',
        cTableId: '',
        courseId: 0,
        sessionId: '',
        questionId,
        roomId: '',
        preHref: '',
        teacherCharacter: '1',
        isLowEndDevice: isLowEndDevice(),
        fileList: [] as any[],
    };

    // 状态管理
    let isTimeout = false;
    let isClientParamsReceived = false;
    const startTime = Date.now();

    // 超时回调
    const onTimeout = () => {
        isTimeout = true;
        if (isClientParamsReceived) {
            skipQuestion();
        }
    };

    // 等待端上参数的 Promise
    const waitClientParams = new Promise<void>(resolve => {
        window.callbackMap.setQuestionParams = (json: any) => {
            const {params, uid, cTableId, courseId, sessionId, roomId, preHref, teacherCharacter, fileList} = JSON.parse(json);
            Object.assign(newParams, {
                uid: uid || '',
                cTableId: cTableId || '',
                courseId: courseId || 0,
                sessionId: sessionId || '',
                roomId: roomId || '',
                preHref: preHref || '',
                teacherCharacter: String(teacherCharacter) || '1',
                fileList: fileList || [],
            });
            consoleLog('客户端参数已接收', newParams);
            consoleLog('客户端传递的题目数据', params);
            isClientParamsReceived = true;

            if (isTimeout) {
                setTimeout(skipQuestion, 1000);
            }
            resolve();
        };
    });

    try {
        const [, res]: [void, any] = await Promise.all([
            waitClientParams,
            fetchQuestionDataWithRetry(questionId, randomSign, startTime, onTimeout)
        ]);

        const callbackId = res.data?.id ?? 0;
        if (res.code === '0' && callbackId !== 0) {
            handleQuestionLoadSuccess(res, newParams);
        }
        else {
            handleQuestionLoadFail(res, questionId);
        }
    }
    catch (error: any) {
        if (!error?.message?.startsWith('REQUEST_TIMEOUT')) {
            // 请求失败不跳题了，正常走超时逻辑
            // skipQuestion();
        }
    }
};


/**
 * 与APP交互的postMessage，通过type判断事件
 *
 * @param {fnName} string 与APP交互的方法名
 * @param {param} object 与APP交互的参数
 *
 */
export const sendMessageApp = (fnName:any, param?:any) => {
    try {
        if (isGaotuEnv()) {
            console.log('sendMessageApp isGaotuEnv', fnName, param);
            // 实现端能力封装
            sendMessageAppInGaotu(fnName, param);
            return;
        }
        // 对部分端能力加一层拦截，进行全局的数据上报
        param = handleSendMessageApp(fnName, param);

        if (isOnlineParamsEnvNext()) {
            sendMessageAppInOnlineWithoutFetch(fnName);
        }
        else if (isOnlineParamsEnv()) {
            sendMessageAppInOnline(fnName);
        }
        if (isAndroid()) {
            if (fnName !== 'logNative') {
                console.log(`调用安卓的端能力，方法：${fnName};参数：${typeof param === 'object' ? JSON.stringify(param) : param}`);
            }
            if (isWebEnv()) {
                return;
            }
            param
                ? window.maodou[fnName](typeof param === 'object' ? JSON.stringify(param) : param)
                : window.maodou[fnName]();
        }
        else if (isIOS()) {
            if (fnName !== 'logNative') {
                console.log(`调用ios的端能力，方法：${fnName};参数：${typeof param === 'object' ? JSON.stringify(param) : param}`);
            }
            if (isWebEnv()) {
                return;
            }
            // ios端能力调用，如果是不传参的情况可以给{}，null，undefined，但是不能什么都不给。
            window?.webkit?.messageHandlers[fnName]?.postMessage(
                typeof param === 'string' ? param : JSON.stringify(param)
            );
        }
    }
    catch (error:any) {
        console.log('sendMessageApp error', error);
        // throw new Error(error);
    }
};


// gio上报
export const gioTrack = (eventName: string, eventSub?: any) => {
    sendMessageApp('growingIoReport', {eventName, eventSub});
};

/**
     * 调用端能力打印日志
     * @param {*} val
     * @returns
     */
export const logNative = (content:any) => {
    try {
        sendMessageApp('logNative', content);
    }
    catch (error) {
        // console.log(content);
    }
};

export const consoleLog = (...content: unknown[]) => {
    console.log(...content);
    try {
        if (!isAndroid()) {
            sendMessageApp('logNative', JSON.stringify(content));
        }
    }
    catch (error) {
        // console.log(content);
    }
};


// 宽高比判断是否是pad
export const aspectRatioIsPad = () => {
    // 计算那一边是短边哪边是长边
    let screenMin;
    let screenMax;
    if (document.body.clientWidth > document.body.clientHeight) {
        screenMin = document.body.clientHeight;
        screenMax = document.body.clientWidth;
    }
    else {
        screenMin = document.body.clientWidth;
        screenMax = document.body.clientHeight;
    }
    console.log('screenMin', screenMin);
    console.log('screenMax', screenMax);
    // 算比例判断是否是pad
    if (screenMin / screenMax >= 0.68) {
        return true;
    }
    return false;
};


// static/spine/maodouCar/tzt_md_begin.json
export const getSpinePath = (path: string, preHref: string) => {
    consoleLog('getSpinePath path', path);
    consoleLog('getSpinePath preHref', preHref);
    consoleLog('getSpinePath isWebEnv', isWebEnv());
    consoleLog('getSpinePath isGaotuEnv', isGaotuEnv());
    const url = window.location.href;
    const routeName = isWebEnv() ? 'spineTopic' : 'spineTopic-pages';
    const index = url.indexOf(routeName);
    let totalPath = `${url.slice(0, index)}${path}`;
    // 安卓不能fetch本地资源，需要起服务并从服务中加载资源，商定域名端口为http://localhost:8887
    if (!isWebEnv() && isAndroid() && !isGaotuEnv()) {
        // 安卓优化，优先使用preHref，没有的话再用之前商定的端口号
        const host = preHref || 'http://localhost:8887';
        const indexStr = 'web_question';
        const indexStart = url.indexOf('web_question') + indexStr.length;
        totalPath = `${host}${url.slice(indexStart, index)}${path}`;
    }
    // ios也不能fetch本地资源，需要起服务并从服务中加载资源，端能力setQuestionParams传递前缀路径
    else if (!isWebEnv() && !isGaotuEnv()) {
        totalPath = `${preHref}${path}`;
    }

    return totalPath;
};

// load spine
export const loadSpine = async (url: string, dom: any, props: any, cb: any) => {
    consoleLog('loadSpine url', url);
    const startTime = Date.now();
    // 5秒超时
    const timeout = 5000;
    let timeoutPromise;
    try {
        timeoutPromise = setTimeout(() => {
            consoleLog('loadSpine 超时');
            // !isWebEnv() && isOnlineParamsEnv() && window.collectEvent('spine_load_timeout', {
            //     url,
            //     ua: window.navigator.userAgent,
            //     buildEnv: process.env.VUE_APP_BUILD_ENV
            // });
            // 端能力上报 spine 加载超时
            questionErrorReport({
                exceptionErrorcode: 100004,
                errorCode: '-32307',
                message: 'spine加载超时',
                extra: JSON.stringify({url}),
            });
        }, timeout);

        const resources = await window.PIXI.Assets.load(url);
        consoleLog('loadSpine 资源下载成功 resources');

        const app = new window.PIXI.Application({
            view: dom,
            backgroundAlpha: 0,
            width: props.width,
            height: props.height,
        });

        const spine = new window.PIXI.spine.Spine(resources.spineData);
        consoleLog('loadSpine spine初始化完成');
        app.stage.addChild(spine);
        spine.x = props.spineX ?? props.width / 2;
        spine.y = props.spineY ?? props.height / 2;
        consoleLog('loadSpine spine添加完成，执行回调函数');

        cb(spine.state);

        // cb执行后再上报加载时间
        const loadTime = Date.now() - startTime;
        clearTimeout(timeoutPromise);
        // !isWebEnv() && isOnlineParamsEnv() && window.collectEvent('spine_load_success', {
        //     url,
        //     loadTime,
        //     ua: window.navigator.userAgent,
        //     buildEnv: process.env.VUE_APP_BUILD_ENV
        // });
    }
    catch (error: any) {
        clearTimeout(timeoutPromise);
        // 上报加载失败，针对这四种错误，进行拦截
        // Unable to auto-detect a suitable renderer
        // 无可用的渲染器
        // This browser does not support WebGL. Try using the canvas renderer
        // 设备不支持 WebGL
        // Invalid value of `0` passed to `checkMaxIfStatementsInShader`
        // spine 加载过程中报错
        // Cannot read property 'Assets' of undefined
        // window.PIXI 注册失败，不兼容 PIXI 库
        const errorMessage = error instanceof Error ? error.message : String(error);
        // !isWebEnv() && isOnlineParamsEnv() && window.collectEvent('spine_load_error', {
        //     url,
        //     error: errorMessage,
        //     loadTime: Date.now() - startTime,
        //     ua: window.navigator.userAgent,
        //     buildEnv: process.env.VUE_APP_BUILD_ENV
        // });
        // 端能力上报 spine 加载失败
        questionErrorReport({
            exceptionErrorcode: 100004,
            errorCode: '',
            message: errorMessage,
            extra: JSON.stringify({url}),
        });
        consoleLog('loadSpine Spine加载失败:', errorMessage);
        cb(null);
    }
};

export const getRefItem = (listOrItem: any) => (listOrItem instanceof Array ? listOrItem[0] : listOrItem);

export const formatWord = (word: string) => word.replace(/[^a-zA-Z0-9]+/g, '');

// 检查性能方案
export const startCheckForStutter = (options: any) => {
    consoleLog('startCheckForStutter');

    // 正常帧间隔（1000 / 60），超过这个值认为可能卡顿
    // const stutterThreshold = 20;
    const startTime = performance.now();
    let frameCount = 1;
    let totalFrameTime = 0;
    let lastTime = performance.now();
    let maxFrameTime = 0;
    let preReportInterval = 0;

    let preStartTime = performance.now();
    let preFrameCount = 1;
    let preTotalFrameTime = 0;
    let preLastTime = performance.now();
    let preMaxFrameTime = 0;

    function checkForStutter() {
        const now = performance.now();
        frameCount++;
        preFrameCount++;
        totalFrameTime = now - startTime;
        preTotalFrameTime = now - preStartTime;
        const frameTime = now - lastTime;
        maxFrameTime = Math.max(maxFrameTime, frameTime);
        const preFrameTime = now - preLastTime;
        preMaxFrameTime = Math.max(preMaxFrameTime, preFrameTime);
        lastTime = now;
        preLastTime = now;
        requestAnimationFrame(checkForStutter);
    }

    requestAnimationFrame(checkForStutter);


    // 上报间隔
    const reportIntervalList = [5000, 10000, 20000, 40000];
    for (const reportInterval of reportIntervalList) {
        setTimeout(() => {
            const avgFrameTime = Math.round(totalFrameTime / frameCount);
            const preAvgFrameTime = Math.round(preTotalFrameTime / preFrameCount);

            consoleLog('reportInterval', reportInterval);
            consoleLog('avgFrameTime', avgFrameTime);
            consoleLog('maxFrameTime', maxFrameTime);
            consoleLog('totalFrameTime', totalFrameTime);
            consoleLog('frameCount', frameCount);
            consoleLog('window.navigator.userAgent', window.navigator.userAgent);
            consoleLog('options.qTypeId', options.qTypeId);
            consoleLog('options.qName', options.qName);
            consoleLog('options.questionId', options.questionId);

            // window.collectEvent('performance_report', {
            //     ua: window.navigator.userAgent,
            //     qTypeId: options.qTypeId,
            //     qName: options.qName,
            //     questionId: options.questionId,
            //     reportInterval,
            //     buildEnv: process.env.VUE_APP_BUILD_ENV,

            //     avgFrameTime,
            //     maxFrameTime: Math.round(maxFrameTime),
            //     totalFrameTime: Math.round(totalFrameTime),
            //     frameCount,

            //     preReportInterval,
            //     preAvgFrameTime,
            //     preMaxFrameTime: Math.round(preMaxFrameTime),
            //     preTotalFrameTime: Math.round(preTotalFrameTime),
            //     preFrameCount,
            // });

            // 重置数据
            preReportInterval = reportInterval;
            preStartTime = performance.now();
            preFrameCount = 1;
            preTotalFrameTime = 0;
            preLastTime = performance.now();
            preMaxFrameTime = 0;

        }, reportInterval);
    }
};


// 是否为低端机型
export const isLowEndDevice = () => {
    const ua = window.navigator.userAgent || '';
    consoleLog('ua', ua);
    // 将所有ipad视为低端机型
    const isLowEndDevice = ua.includes('iPad');
    consoleLog('isLowEndDevice', isLowEndDevice);
    return isLowEndDevice;
};

// 题目类型与操作语音的映射配置
const OPERATION_AUDIO_MAP: Record<string, string> = {
    // 魔法云朵题
    30003: 'https://p.gsxcdn.com/3346551793_8iu2cblp.mp3',
    // 排序题
    30008: 'https://p.gsxcdn.com/3346556930_ndyovz8u.mp3',
    // 拖拽匹配题
    30009: 'https://p.gsxcdn.com/3346556922_mmnmgwgn.mp3',
    // 找东西题
    503: 'https://p.gsxcdn.com/3346556924_17fwrxbv.mp3',
    // 找字题
    511: 'https://p.gsxcdn.com/3346556924_17fwrxbv.mp3',
};

// 操作语音最大播放次数
const MAX_AUDIO_PLAY_COUNT = 3;

/**
 * 获取题目操作语音播放信息（集中管理播放次数和音频链接）
 * @param {string | number} qTypeId 题目类型ID
 * @returns {{shouldPlay: boolean; audioUrl: string; playCount: number}} 播放信息
 * - shouldPlay: 是否应该播放
 * - audioUrl: 音频链接
 * - playCount: 当前播放次数
 */
export const getAudioPlayCount = (qTypeId: string | number): {
    shouldPlay: boolean;
    audioUrl: string;
    playCount: number;
} => {
    try {
        const typeId = String(qTypeId);
        const key = `audioPlayCount_${typeId}`;

        // 获取当前播放次数
        const countStr = localStorage.getItem(key);
        const playCount = countStr ? parseInt(countStr, 10) : 0;

        // 获取对应的音频链接
        const audioUrl = OPERATION_AUDIO_MAP[typeId] || '';

        // 判断是否应该播放（次数小于最大值且有音频链接）
        const shouldPlay = playCount < MAX_AUDIO_PLAY_COUNT && !!audioUrl;

        consoleLog(`题目类型 ${typeId} 操作语音播放信息:`, {
            playCount,
            shouldPlay,
            audioUrl,
        });

        return {
            shouldPlay,
            audioUrl,
            playCount,
        };
    }
    catch (error) {
        consoleLog('getAudioPlayCount error', error);
        return {
            shouldPlay: false,
            audioUrl: '',
            playCount: 0,
        };
    }
};

/**
 * 更新题目操作语音的播放次数
 * @param {string | number} qTypeId 题目类型ID
 * @returns {number} 更新后的播放次数
 */
export const updateAudioPlayCount = (qTypeId: string | number): number => {
    try {
        const typeId = String(qTypeId);
        const key = `audioPlayCount_${typeId}`;
        const {playCount} = getAudioPlayCount(typeId);
        const newCount = playCount + 1;
        localStorage.setItem(key, newCount.toString());
        consoleLog(`题目类型 ${typeId} 操作语音播放次数更新: ${playCount} -> ${newCount}`);
        return newCount;
    }
    catch (error) {
        consoleLog('updateAudioPlayCount error', error);
        return 0;
    }
};

const getVersion = () => {
    const {appverint, appVersion} = parseUrl();
    let versionNumber = 10000;
    if (appverint) {
        versionNumber = appverint;
    }
    else if (appVersion) {
        versionNumber = +(String(appverint).replaceAll('.', ''));
    }
    if (versionNumber < 14100) {
        return '低于1.41.00版本';
    }
    return String(versionNumber);

};
const ydVision = getVersion();
export const maidianReport = (eventName:string, params:any = {}) => {
    try {
        if (eventName !== 'config') {
            // eslint-disable-next-line camelcase
            params.yd_vision = ydVision;
        }

        window.collectEvent(eventName, params);
    }
    catch {
        consoleLog('埋点上报失败');
    }
};
